<template>
  <div class="custom-text">
    <vs-row>
      <vs-col vs-xs="12" vs-sm="6" vs-lg="6">
        <table>
          <tr>
            <td class="font-semibold">{{ $t('status') | capitalize }}:</td>
            <td>
              <vs-chip
                :color="
                  data.status_color !== undefined
                    ? data.status_color.trim()
                    : '#F4F4F4'
                "
                >{{ data.status_name }}</vs-chip
              >
            </td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('invoice_type') | capitalize }}:
            </td>
            <td>{{ data.invoice_type_name || '' }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('bundles') | capitalize }}:</td>
            <td>{{ data.bundles }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('location') | capitalize }}:</td>
            <td>{{ data.location }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $t('destination') | capitalize }}:</td>
            <td>{{ data.destination }}</td>
          </tr>
          <tr>
            <td class="font-semibold">{{ $tc('po_number') | capitalize }}:</td>
            <td>{{ data.po_number }}</td>
          </tr>
          <tr>
            <td class="font-semibold">
              {{ $t('discrepancies') | capitalize }}:
            </td>
            <td>{{ data.discrepancies }}</td>
          </tr>
        </table>

        <p class="font-semibold">{{ $t('comments') | capitalize }}:</p>
        <p>{{ data.comments }}</p>
      </vs-col>
      <vs-col vs-xs="12" vs-sm="4" vs-lg="4">
        <vs-row>
          <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" >
           <vue-apex-charts  type="radialBar" height="220" :options="chartOptions" :series="seriesSpeedMeter" />
          </vs-col>
          <vs-col vs-w="12" vs-type="flex" vs-justify="flex-end" style="color:red;margin-right:8em">{{totalDiscrepancies}} {{$t('discrepancies')|capitalize}}</vs-col>
          <vs-col vs-w="12" class="mt-4">
            <table>
              <tr>
                <td class="font-semibold">
                  {{ $t('created_by') | capitalize }}:
                </td>
                <td>{{ data.created_by_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ $t('reviewed_by') | capitalize }}:
                </td>
                <td>{{ data.reviewed_by_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">
                  {{ $t('warehouse') | capitalize }}:
                </td>
                <td>{{ data.warehouse }}</td>
              </tr>
            </table>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components:{
    VueApexCharts
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: '',
        status_name: '',
        status_color: '#F4F4F4',
        invoice_type_name: '',
        bundles: '',
        location: '',
        destination: '',
        po_number: '',
        discrepancies: '',
        comments: '',
        created_by_name: '',
        reviewed_by_name: '',
        warehouse: '',
        entries_id: ''
      })
    },
    seriesSpeedMeter:{
      type: Array,
      default: function () {
        return [0]
      }
    },
    totalDiscrepancies:{
      type: String,
      default:'0'
    }
  },
  data(){
    return {
      series: [76],
      chartOptions: {
        chart: {
          type: 'radialBar',
          offsetY: -20,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
              background: "#e7e7e7",
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: -2,
                fontSize: '22px'
              }
            }
          }
        },
        grid: {
          padding: {
            top: -10
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          },
        },
        labels: ['Average Results'],
      },
    }
  }
}
</script>

<style>
.custom-text {
  font-size: 12px;
}
</style>
